import { Box, Button } from "@mui/material";
import { OrganizationUserContext } from "contexts/Organization";
import { SubscriptionContext, SubscriptionTab } from "contexts/Subscription";
import { useContext } from "react";
import { isQuarterlyPlan } from "schemas/payments";

import { isB2GOPromoActive } from "constants/influencer";
import { trackEvent } from "utils/tracking";

import styles from "./styles";

const SubscriptionButton = () => {
  const { tab, setTab, subscription } = useContext(SubscriptionContext);
  const { currentOrg } = useContext(OrganizationUserContext);

  const showQuarterlyTab =
    isB2GOPromoActive() ||
    (currentOrg?.isPaidUser &&
      isQuarterlyPlan(subscription?.subscription?.planName));

  const switchTab = (tabValue: SubscriptionTab) => {
    trackEvent("Subscription Plan Tab Changed", { Tab: tabValue });
    setTab(tabValue);
  };
  return (
    <Box sx={styles.container}>
      <Button
        onClick={() => switchTab(SubscriptionTab.monthly)}
        sx={[
          styles.button,
          tab === SubscriptionTab.monthly ? styles.active : styles.inactive,
        ]}
      >
        Monthly
      </Button>
      <Button
        onClick={() => switchTab(SubscriptionTab.yearly)}
        sx={[
          styles.button,
          tab === SubscriptionTab.yearly ? styles.active : styles.inactive,
        ]}
      >
        Yearly
        <Box sx={styles.yearlyText}>SAVE 25%</Box>
      </Button>
      {showQuarterlyTab && (
        <Button
          onClick={() => switchTab(SubscriptionTab.quarterly)}
          sx={[
            styles.button,
            tab === SubscriptionTab.quarterly
              ? styles.promoActive
              : styles.promoInactive,
          ]}
        >
          <Box
            component="i"
            className="fa-solid fa-gift"
            sx={{ mr: 0.75, fontSize: 12 }}
          />
          Buy 2, Get 1<Box sx={styles.limitedText}>LIMITED</Box>
        </Button>
      )}
    </Box>
  );
};

export default SubscriptionButton;
